// @ts-check
/**
 * @file outboxActions.js
 * @location src/store/reducers/outboxActions.js
 * @role outbox 큐 액션 — 다른 도메인 리듀서와 분리된 인프라 상태.
 *
 *  OUTBOX_ENQUEUE       — 새 entry 적재 (낙관적 RPC 실패 시 useSupabaseStore 가 호출)
 *  OUTBOX_REMOVE        — 플러시 성공 시 1건 제거
 *  OUTBOX_DROP_STALE    — 7일 이상 큐에 머문 entry 일괄 제거 (앱 부팅 시 1회 + 주기)
 *
 *  pure 헬퍼는 src/utils/outbox.js — 데이터 변형만 거기서 (테스트 분리).
 *
 * 핸들러 맵 스타일(templateActions·autoActions 동일)로 export → reducers/index.js 에 스프레드.
 * 테스트 호환을 위해 함수 래퍼 outboxActions 도 같이 export.
 */
import { addEntry, removeEntry, dropStaleEntries } from '../../utils/outbox.js';

/** 핸들러 맵 — reducers/index.js 에 스프레드 */
export const outboxHandlers = {
  OUTBOX_ENQUEUE: (state, action) => ({
    ...state,
    outbox: addEntry(state.outbox ?? [], action.entry, Date.now()),
  }),
  OUTBOX_REMOVE: (state, action) => ({
    ...state,
    outbox: removeEntry(state.outbox ?? [], action.id),
  }),
  OUTBOX_DROP_STALE: (state) => ({
    ...state,
    outbox: dropStaleEntries(state.outbox ?? [], Date.now()),
  }),
};

/**
 * 함수 스타일 래퍼 — 테스트 및 직접 합성 시 사용.
 * @param {object} state
 * @param {{ type: string, [key: string]: unknown }} action
 * @returns {object}
 */
export function outboxActions(state, action) {
  const handler = outboxHandlers[action.type];
  return handler ? handler(state, action) : state;
}
